import { useParams } from "react-router";
import { DaForgotPassword } from "../../components/DaForgotPassword/DaForgotPassword";

function DaForgotPasswordPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaForgotPassword /> : null}
    </div>
  );
}

export default DaForgotPasswordPage;
